/**
 * HomeSLDemoHelpContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoHelpContent
 */

import { useHomeSLDemoHelpContentLogic } from '@/hooks/traits/useHomeSLDemoHelpContentLogic';
import type { HomeSLDemoHelpContentConfig } from '@/hooks/traits/useHomeSLDemoHelpContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoHelpTicket } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { HomeSLDemoHelpStatsView } from '@/components/traits/HomeSLDemoHelpStatsView';
import { Stack } from '@almadar/ui/components';
import { HomeSLDemoTicketQueueView } from '@/components/traits/HomeSLDemoTicketQueueView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLDemoHelpContentViewProps {
  config?: Partial<HomeSLDemoHelpContentConfig>;
}

export function HomeSLDemoHelpContentView({ config: propsConfig }: HomeSLDemoHelpContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLDemoHelpContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoHelpTicket'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLDemoHelpContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-4" direction="vertical" gap="sm"><Stack direction="horizontal" gap="sm" align="baseline"><Typography variant="h3" content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.title"))} /><Typography variant="small" content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.subtitle"))} color="muted" /></Stack><HomeSLDemoHelpStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeSLDemoTicketQueueView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLDemoHelpContentView;
